export default __webpack_public_path__ + "static/media/bg8.20e9b85c.jpg";